import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormHelperText } from '@mui/material';

const SelectComponent = ({ id, label, value, setValue, items, multiselect, error, disabled, sx, shrink, helperText }) => {
  return (
    <>
      <FormControl fullWidth error={error} disabled={disabled}>
        <InputLabel id="demo-simple-select-label" shrink={shrink}>{label}</InputLabel>
        <Select
          id={id}
          name={id || label?.toLowerCase().replace(/\s+/g, '_')}
          value={value}
          label={label}
          multiple={multiselect}
          onChange={(event) => setValue(event.target.value)}
          sx={sx}
        >
          {items?.map((i) => {
            return (
              <MenuItem value={i.id} key={i.id}>
                {i.name}
              </MenuItem>
            );
          })}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </>
  );
};

export default SelectComponent;
